import FonctApi from "../api/FonctApi";

export default {
    namespaced: true,
    state:{
        fonctionnality: {}
    },
    mutations:{
        setFonctionnality(state, fonctionnality) {
            state.fonctionnality = fonctionnality;
        }
    },
    actions: {
        fonctsAllAction({commit}){
            FonctApi.fonctAll()
                .then(res => {
                    commit('setFonctionnality',res.data)
                })
        }
    }
}
